import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  useLocation,
  useRoutes,
} from "react-router-dom";
import AuthLayout from "../layouts/auth-layout";
import DashboardLayout from "../layouts/dashboard-layout";
import Login from "../pages/auth/login";
import SignUp from "../pages/auth/register";
import Dashboard from "../pages/dashboard/dashboard";
import ForgotPassword from "../pages/auth/forgot-password";
import UpdatePassword from "../pages/auth/update-password";
import MainLayout from "../layouts/main-layout";
import RoleList from "../pages/dashboard/roles/list";
import UserList from "../pages/dashboard/users/list";
import LogsList from "../pages/dashboard/logs/list";
import NotFound from "../pages/errors/not-found/not-found";
import Forbidden from "../pages/errors/forbidden/forbidden";
import { UserContext } from "../context";
// import ConfigurationList from "../pages/dashboard/configuration/list";
import ResetPassword from "../pages/auth/reset-password";
import ProjectList from "../pages/dashboard/configurations/wrapper";
import ProjectManagement from "../pages/dashboard/project-management/list";
import ConfigMappingsWrapper from "../pages/dashboard/config-mappings/wrapper";
import ConfigurationsWrapper from "../pages/dashboard/configurations/wrapper";
import AssessmentWrapper from "../pages/dashboard/assessment";
import GetAssessmentList from "../pages/dashboard/assessment/performance/list";
import KPICycleList from "../pages/dashboard/assessment/KPICycle/list";
import ApiManager from "../pages/dashboard/api-manager";
import UserAssessmentHistoryList from "../pages/dashboard/assessment/performance/userAssessmentHistory";

const routes = [
  {
    path: "/login",
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },
  {
    path: "/signUp",
    element: (
      <AuthLayout>
        <SignUp />
      </AuthLayout>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <AuthLayout>
        <ForgotPassword />
      </AuthLayout>
    ),
  },
  {
    path: "/update-password",
    element: (
      <MainLayout>
        <UpdatePassword />
      </MainLayout>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <MainLayout>
        <ResetPassword />
      </MainLayout>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <DashboardLayout>
        <Dashboard />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/users",
    element: (
      <DashboardLayout>
        <UserList />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/roles",
    element: (
      <DashboardLayout>
        <RoleList />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/logs",
    element: (
      <DashboardLayout>
        <LogsList />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/project",
    element: (
      <DashboardLayout>
        <ProjectManagement />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/assessment",
    element: (
      <DashboardLayout>
        <AssessmentWrapper />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/assessmentreviewlist",
    element: (
      <DashboardLayout>
        <GetAssessmentList />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/kpicyclelist",
    element: (
      <DashboardLayout>
        <KPICycleList />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/api-manager",
    element: (
      <DashboardLayout>
        <ApiManager />
      </DashboardLayout>
    ),
  },
  {
    path: "/dashboard/assessment-history",
    element: (
      <DashboardLayout>
        <UserAssessmentHistoryList />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/project-master",
    element: (
      <DashboardLayout>
        <ConfigurationsWrapper />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/config-project",
    element: (
      <DashboardLayout>
        <ConfigMappingsWrapper />
      </DashboardLayout>
    ),
  },

  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "*",
    element: (
      <DashboardLayout>
        <NotFound />
      </DashboardLayout>
    ),
  },
  {
    path: "/forbidden",
    element: (
      <DashboardLayout>
        <Forbidden />
      </DashboardLayout>
    ),
  },
];

const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
  const userData: any = useContext(UserContext);
  const authorizedRoutes =
    userData?.menuHierarchy?.map((item: any) =>
      item?.entityUrl.toLocaleLowerCase(),
    ) || [];

  const location = useLocation();
  const currentPath = location.pathname.toLocaleLowerCase();

  // Define excluded paths
  const excludedPaths = ["/dashboard/dealers/form", "/dashboard/ticket/form"];

  // Check if the current path is excluded
  const isExcluded = excludedPaths.includes(currentPath);

  // Check authorization only for non-excluded paths
  // const isAuthorized = isExcluded || authorizedRoutes?.includes(currentPath);
  const isAuthorized = true;

  if (!isAuthorized && authorizedRoutes?.length > 0) {
    return <Navigate to="/forbidden" replace />;
  }

  return element;
};

const AppRoutes: React.FC = () => {
  const element = useRoutes(
    routes.map((route) => ({
      ...route,
      element: route.path.startsWith("/dashboard") ? (
        <ProtectedRoute element={route.element} />
      ) : (
        route.element
      ),
    })),
  );

  return <>{element}</>;
};

const App: React.FC = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
